<template>
  <div class="call-amount-trend-line">
    <div ref="container" style="width:100%;height:230px;"></div>
  </div>
</template>

<script>
import Echart from 'echarts'
import _ from 'lodash'
export default {
  props: {
    data: {
      default() {
        return [
          {
            name: '接听',
            value: [
              { x: '10:00', y: 30 },
              { x: '08:00', y: 30 },
              { x: '09:00', y: 70 }
            ]
          },
          {
            name: '呼出',
            value: [
              { x: '08:00', y: 130 },
              { x: '09:00', y: 270 },
              { x: '10:00', y: 330 }
            ]
          },
          {
            name: '未接',
            value: [
              { x: '08:00', y: 390 },
              { x: '09:00', y: 170 },
              { x: '10:00', y: 380 }
            ]
          }
        ]
      }
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      let option = {
        legend: {
          x: '220',
          data: _.map(this.data, e => e.name)
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: _.chain(this.data).map(e => _.map(e.value, v => v.x)).flattenDeep().uniq().sort().value()
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: _.map(this.data, e => {
          return {
            name: e.name,
            silent: true,
            type: 'line',
            smooth: false,
            data: _.chain(e.value).map(e => [e.x, e.y]).sortBy(e => e[0]).value()
          }
        })
      }
      if (this.chart) {
        this.chart.dispose()
      }
      let chart = Echart.init(this.$refs.container)
      chart.setOption(option)
      this.chart = chart
    }
  },
  watch: {
    data() {
      this.refresh()
    }
  }
}
</script>
